import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectIsInstructor, UntilDestroy, untilDestroyed } from '@shared';
import { firstValueFrom } from 'rxjs';
import { LoaderService, Logger } from 'thkee-common';

const log = new Logger('InstructorGuard');
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class InstructorGuard {
  isLoading$ = this.loaderService.response('loading-me');

  constructor(private router: Router, private readonly store: Store<AppState>, private loaderService: LoaderService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.isLoading$.pipe(untilDestroyed(this)).subscribe((res) => {
      if (res === 'success') {
        setTimeout(() => {
          firstValueFrom(this.store.select(selectIsInstructor)).then((instructor) => {
            if (instructor) {
              return true;
            } else {
              this.router.navigate(['/become-an-instructor']);
              return false;
            }
          });
        });
        // return this.store.select(selectIsInstructor).pipe(
        //   skipUndefined(),
        //   map((isInstructor) => {
        //     // const is_alreadyInstructor = await firstValueFrom(this.store.select(selectIsInstructor));
        //     if (isInstructor) {
        //       return true; // Allow navigation
        //     } else {
        //       this.router.navigate(['/home']);
        //       return false; // Prevent navigation
        //     }
        //   })
        // );
      }
      if (res === 'failed') {
        this.router.navigate(['/home']);
      }
    });
  }
}
